module.exports = __webpack_public_path__ + "static/hero-bbd970cc5feea57dd7aca5b3ecece30f.jpg";